import { cn } from "~/lib/utils";

interface BottomSheetHandleProps {
  className?: string;
}

export function BottomSheetHandle({ className }: BottomSheetHandleProps) {
  return (
    <div data-slot="bottom-sheet-handle" className={cn("flex justify-center py-2", className)}>
      <div className="bg-muted-foreground/30 h-1.5 w-16 rounded-full" />
    </div>
  );
}
